module.exports = __webpack_public_path__ + "img/f44487c.png";